import { createContext } from 'react'

import type { ExtendedUser, UserContext as UserContextValue } from '../types'

export const UserContext = createContext<UserContextValue<ExtendedUser>>({
  clerkUserId: null,
  isLoading: true,
  isSilentlyLoading: false,
  refresh: () => Promise.resolve(null),
  reload: () => Promise.resolve(null),
  set: () => {},
  user: null,
  wasProvided: false,
})

/** @alias */
export default UserContext
